import { Fragment, useState } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import { Link } from "react-router-dom";
import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";


function FreeEditE(props)
{

       
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [view,setView] = useState('link');

    const [row, setRow] = useState( props.row );

    
 
    const [title, setTitle] = useState(props.title);

    
    //var tempRow = row;

    //console.log(row);

    const valChangeListener = (filedName, val, correct, msg) => {
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  




    const goChange = () => {
        setView("dialog");    
    }

    const closeDialog = () => {       
        setView('link');
        
    }

    const saveTab = () => {

            setView('link');
 
                props.mainView.setProgress(-2);
        
                fetch( Config.url + '/rest_v1_employessModule,free_update', {
                    method: 'POST', 
                    body: JSON.stringify(row), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                        '_sec_key_': Config.genXKey() ,
                    }
                 })
                 .then(res => res.json() )
                 .then(res => { 
        
                            props.mainView.setProgress(-1);        
                            if(res._sys_ == undefined)
                            {
                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                            }else    
                            {
                                ///   
                                props.onSucess();    
                                setRow(props.row);                                         
                            }
                 } )
                 .catch(err => {          
                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                            props.mainView.setProgress(-1);
                 });
                           
        
             
           
    }


 
    //if(row.dzien != props.row.dzien)    
    //{   
        //setRow(props.row);
    //}
 
    
 


    var dlg = null;

        if(view == 'dialog')
        {
           

            dlg = <div className="dlg_window dlg_type_x shadowx">
                    <div className="dlg_title">{title}</div>            

                    <div className="dlg_msg">
                        
                        
                        <div>
                           
                        </div>

                            <div className="form_tab">                                

                                <div className="form_control">
                                    <div className="fieldName">Dzień </div>
                                    <InputDate  value={row.dzien} err={errTab}  valChange={valChangeListener}  name="dzien" placeholder={"Dzień: "} className=' w250 ' req='1'   />
                                </div>

                                <div className="form_control">
                                    <div className="fieldName">Kategoria</div>
                                    <InputCombo  items={props.powody}  value={row.sl_powodow_nieobecnosci_id} err={errTab}  valChange={valChangeListener}  name="sl_powodow_nieobecnosci_id" placeholder={"Kategoria: "} className=' w250 ' req='1'   />
                                </div>

                                <br/>

                                <div className="form_control">
                                    <div className="fieldName">Informacje dodatkowe</div>
                                    <InputText   value={row.powod} err={errTab}  valChange={valChangeListener}  name="powod" placeholder={"Informacje dodatkowe: "} className=' w250 ' req='0'   />
                                </div>

                               

                            </div>


                    </div>

                    <div className="dlg_btn dlg_btn_mobile">
                          <div className="btn btn_in" atr-type="save" onClick={saveTab}>Zapisz</div>
                         
                          <div className="btn btn_back" atr-type="cancel" onClick={closeDialog}>Anuluj</div>
                    </div>
            </div>
        }

        if(view == 'link')
        {
            return (
                <div className="btn" onClick={goChange}  v="new" id="-1"  >Dodaj urlop</div>
            )
        }

     
    

 
    
    var defText = '';
    if(defText.length < 1) defText = "---";
    
    return (
        <td className={props.className}>            
             <span onClick={goChange}>{defText}</span>
             {dlg}
             {props.children}
        </td>
    )
}

export default FreeEditE;
